// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const ConnectButton: MarkdocTagRegistration = {
  tag: 'connect-button',
  component: 'ConnectButton',
  attributes: {
    token: {type: String},
  },
};
